import { useState } from 'react'
import { createFileRoute, useNavigate, Link } from '@tanstack/react-router'
import { useLoginMutation } from '@/domains/auth/queries'
import { useAppForm } from '@/lib/form'
import {
  loginFormOpts,
  loginFormSchema,
} from '@/domains/auth/form/form-options'
import { LoginForm } from '@/domains/auth/form/auth-form'
import { HttpError } from '@/lib/http'

export const Route = createFileRoute('/login')({
  component: RouteComponent,
})

function RouteComponent() {
  const [loginFailed, setLoginFailed] = useState(false)
  const { mutateAsync: login } = useLoginMutation()
  const navigate = useNavigate()

  const form = useAppForm({
    ...loginFormOpts,
    validators: {
      onSubmit: loginFormSchema,
    },
    onSubmit: async ({ value }) => {
      try {
        setLoginFailed(false)
        await login(value)
        navigate({ to: '/' })
      } catch (error) {
        if (error instanceof HttpError && error.status === 401) {
          setLoginFailed(true)
          return
        }
        throw error
      }
    },
  })

  return (
    <div className="flex-1 flex justify-center items-center overflow-hidden px-5">
      <div className="w-full max-w-sm flex flex-col gap-3">
        <form
          onSubmit={(e) => {
            e.preventDefault()
            form.handleSubmit()
          }}
        >
          <LoginForm
            form={form}
            title="Login"
            description="Welcome back to Powka."
            submitLabel="Log In"
          />
        </form>
        {loginFailed && (
          <p className="text-sm text-center text-destructive">
            Invalid email or password.
          </p>
        )}
        <p className="text-sm text-center text-muted-foreground">
          Don't have an account?{' '}
          <Link to="/signup" className="text-primary underline">
            Sign up
          </Link>
        </p>
      </div>
    </div>
  )
}
